export default __webpack_public_path__ + "static/tatum@2x-39e9188d80880680b8665de1eb55da2a.png";